import { styled } from '@mui/material'

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(1.5, 2),
  borderRadius: '4px 4px 0 0',
}))

export const CheckboxContainer = styled(Container)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: 0,

  '& .MuiFormControlLabel-root': {
    justifyContent: 'flex-start',
    margin: 0,
    height: 48,
    marginTop: -12,
    marginBottom: -12,
  },

  '& .MuiCheckbox-root': {
    marginLeft: -9,
    marginTop: -9,
    marginBottom: -9,
  },
}))
